<nav
  class="nav-bar"
  [class.nav-bar--mobile]="isMobile()"
  [class.nav-bar--desktop]="isDesktop()"
>
  @for (item of navBarItems; track item.key) {
    <cheelee-squircle
      radius="20"
      #rla="routerLinkActive"
      class="nav-bar-item"
      routerLinkActive="nav-bar-item--active"
      [routerLinkActiveOptions]="{ exact: true }"
      [analytics]="item.eventName"
      throttleTime="1000"
      [routerLink]="item.link"
      (cheeleeThrottleClick)="onItemClick(item, $event)"
    >
      @if (item.secondLink) {
        <a [routerLink]="item.secondLink"></a>
      }
      <cheelee-icon class="nav-bar-item__icon" [path]="rla.isActive ? item.icon.activeName : item.icon.defaultName" size="28" />
      <span class="nav-bar-item__text">{{ 'tabbar:' + item.key | i18nextEager }}</span>
    </cheelee-squircle>
  }
</nav>
